import(/* webpackMode: "eager", webpackExports: ["SearchPage"] */ "/home/buyme/htdocs/buyme.lk/src/components/SearchPage.tsx");
